import { Spinner } from '@chakra-ui/react';
import { Icon, IconButton, Tooltip } from '../ui';

interface RefreshButtonProps {
    refetch: () => void;
    size?: 'toolbar' | 'sm' | 'md' | 'lg' | 'xs';
    isLoading: boolean;
}

const RefreshButton = ({ refetch, size = 'toolbar', isLoading }: RefreshButtonProps) => {
    return (
        <Tooltip label="Update" placement="bottom" hasArrow>
            <IconButton
                aria-label="Update"
                icon={isLoading ? <Spinner size="sm" /> : <Icon name="refresh" size="sm" />}
                size={size}
                variant="ghost"
                colorScheme="gray"
                color="fg.muted"
                onClick={refetch}
                isDisabled={isLoading}
            />
        </Tooltip>
    );
};

export default RefreshButton;
